import { parseGameTime, formatTimestamp } from '../../helpers/redeemTimeUtils';
import { formatLamports, formatTokenAmount, truncateAddress } from '../../helpers/redeemFormatUtils';
import RedeemStatusBadge from './RedeemStatusBadge';
import './ClosedGamesTable.css';

function ClosedGamesTable({ games }) {
  if (games.length === 0) {
    return (
      <div className="closed-table-empty">
        <p>No closed games found.</p>
      </div>
    );
  }

  return (
    <div className="closed-table-container">
      <table className="closed-table">
        <thead>
          <tr>
            <th>Game ID</th>
            <th>Status</th>
            <th>Mint</th>
            <th>Final Reserve (SOL)</th>
            <th>Final Supply</th>
            <th>Closed Time</th>
            <th>TX Signature</th>
          </tr>
        </thead>
        <tbody>
          {games.map((game) => {
            const closedTime = parseGameTime(game.closed_time);
            const hasTxSignature = Boolean(game.finalized_tx_signature);

            return (
              <tr key={game.game_id}>
                <td className="closed-table__game-id">#{game.game_id}</td>
                <td>
                  <RedeemStatusBadge status={game.status_code} />
                </td>
                <td className="closed-table__address" title={game.mint}>
                  {truncateAddress(game.mint, 6, 4)}
                </td>
                <td className="closed-table__reserve">
                  {formatLamports(game.final_reserve_snapshot_lamports)} SOL
                </td>
                <td className="closed-table__supply">
                  {formatTokenAmount(game.final_supply_snapshot, 9)}
                </td>
                <td className="closed-table__timestamp">
                  {formatTimestamp(closedTime)}
                </td>
                <td className="closed-table__tx">
                  {hasTxSignature ? (
                    <a
                      href={`https://solscan.io/tx/${game.finalized_tx_signature}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="closed-table__tx-link"
                      title={game.finalized_tx_signature}
                    >
                      {truncateAddress(game.finalized_tx_signature, 8, 8)}
                    </a>
                  ) : (
                    <span className="closed-table__tx-none">N/A</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ClosedGamesTable;
